module.exports = __webpack_public_path__ + "static/map-e748462f07f07e0d19afe271f9abe7ee.png";